import React from 'react';
import StatusDot from './StatusDot';

interface FeatureItemProps {
  label: string;
  status?: string | null;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ label, status }) => {
  const isStandard = status?.toLowerCase() === 'standard';
  const isOptional = status?.toLowerCase() === 'optional';

  return (
    <div className="flex items-center gap-3 py-2">
      <StatusDot status={status} />
      <span
        className={`text-sm ${
          isStandard
            ? 'text-[#0f172a]'
            : isOptional
            ? 'text-[#d97706]'
            : 'text-[#94a3b8]'
        }`}
      >
        {label}
      </span>
    </div>
  );
};

export default FeatureItem;
